import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
type Props = { cards: any };

class HistoricalDataCards extends React.PureComponent<Props> {

  metric(label: string, value: any, tone?: string) {
    return (
      <Grid size={{ xs: 6, md: 3 }} key={label}>
        <Card elevation={1}>
          <CardContent>
            <Typography variant="caption" color="text.secondary">
              {label}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                color: tone ? `${tone}.main` : 'text.primary',
              }}
            >
              {value ?? 0}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    );
  }

  render() {
    const c = this.props.cards || {};
    return (
      <Grid container spacing={2}>
        {this.metric('Imports', c.imports)}
        {this.metric('Validated', c.validated, 'success')}
        {this.metric('Errors', c.errors, c.errors ? 'error' : 'success')}
        {this.metric('Published Facts', c.facts, 'info')}
      </Grid>
    );
  }
}

export default HistoricalDataCards;
